import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import Slider from "react-slick";
import { useNavigate, useParams } from "react-router-dom";
import { Overview } from "Views/Private/Admin/ApplicationStatus/Overview";
import { Email } from "Views/Private/Admin/ApplicationStatus/Email";
import { Document } from "Views/Private/Admin/ApplicationStatus/Document";
// import { Activity } from "./Activity";
import { newAuthService } from "Service/Axios";
import { GET_APPLICANT_OVERVIEW_DETAILS_URL } from "Constant/api";
import {
  useApplicantDetails,
  useApplicantProjectList,
} from "Constant/apiHooks";
import { paths } from "Constant/paths";
import {
  formatDateWithFullMonth,
  formatDateWithTime,
  getFirstLetterOfName,
} from "Utils";

const settings = {
  dots: false,
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const ApplicantDetails = () => {
  const { gid } = useParams();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("backgroundCheck");
  const { applicantDetails } = useApplicantDetails(gid);
  const { applicantProjectList } = useApplicantProjectList(gid);

  // Listing
  const getApplicationOverview = async () => {
    const payload = { userId: gid };
    const response = await newAuthService(
      GET_APPLICANT_OVERVIEW_DETAILS_URL,
      "POST",
      payload
    );
    if (response.status) {
    } else {
    }
  };

  useEffect(() => {
    getApplicationOverview();
  }, []);

  // On Change
  const handleChangeTab = (tab) => {
    setActiveTab(tab);
  };

  // Redirect
  const {
    admin: {
      applicationStatus: { root: applicationStatus, overview },
    },
  } = paths;

  const handleRedirect = (appId) => {
    navigate(`${applicationStatus}/${appId}${overview}`);
  };

  return (
    <main className="main">
      <div className="rounded-3 bg-white">
        {applicantDetails && (
          <div className="d-flex p-4 border-bottom border-slate-200">
            <div className="w-20 h-20 me-2 text-white rounded-circle bg-grey-100 position-relative overflow-hidden">
              {applicantDetails.photoURL ? (
                <img
                  src={applicantDetails.photoURL}
                  alt={`${applicantDetails.firstName}${applicantDetails.lastName}`}
                  className="w-100 h-100 object-fit-cover"
                />
              ) : (
                getFirstLetterOfName(applicantDetails)
              )}
            </div>
            <div className="d-flex flex-column row-gap-1 align-items-start">
              <h3 className="h5 mb-0 font-semibold text-slate-700">
                {applicantDetails.firstName} {applicantDetails.lastName}
              </h3>
              <ul className="m-0 p-0 list-unstyled text-sm text-slate-400 d-flex flex-wrap column-gap-2">
                <li>{applicantDetails.type}</li>
                {/* <li>|</li> */}
                {/* <li>Vancouver, Canada</li> */}
              </ul>
              <ul className="m-0 p-0 list-unstyled text-sm text-slate-500 d-flex flex-wrap column-gap-3 font-medium">
                <li className="d-flex align-items-center">
                  <span className="material-symbols-outlined text-base me-1 text-slate-400">
                    calendar_today
                  </span>
                  Joined{" "}
                  {applicantDetails.createdOn
                    ? formatDateWithFullMonth(applicantDetails.createdOn)
                    : ""}
                </li>
                <li className="d-flex align-items-center">
                  <span className="material-symbols-outlined text-base me-1 text-slate-400">
                    schedule
                  </span>
                  {/* 6:45 local time */}
                  {formatDateWithTime(`${new Date()}`)}
                </li>
              </ul>
              <ul className="m-0 p-0 list-unstyled text-sm text-slate-500 d-flex flex-wrap column-gap-3 font-medium">
                <li className="d-flex align-items-center">
                  <span className="material-symbols-outlined text-base me-1 text-slate-400">
                    mail
                  </span>
                  {applicantDetails.email}
                </li>
              </ul>
            </div>
          </div>
        )}
        <div className="p-4 border-bottom border-slate-200">
          <h3 className="text-md font-semibold text-slate-600">Programs</h3>
          <div className="slick-top-nav">
            <Slider {...settings}>
              {applicantProjectList?.length > 0 &&
                applicantProjectList.map((project, index) => (
                  <div
                    role="button"
                    className="px-1"
                    key={`${project.formId}-${index}`}
                    onClick={() => handleRedirect(project.appId)}
                  >
                    <div className="p-3 rounded-2 border border-slate-200 d-flex align-items-start flex-column row-gap-2">
                      <span
                        className="px-3 py-1 text-xs font-medium rounded-1 border"
                        style={{
                          backgroundColor: project.backgroundColor,
                          color: project.fontColor,
                        }}
                      >
                        {project.status}
                      </span>
                      <h4 className="mb-0 text-sm font-medium text-slate-600">
                        {project.formName}
                      </h4>
                      {/* <p className="mb-0 text-xs font-medium text-slate-400">
                      School of Management Studies (SOMS)
                    </p> */}
                    </div>
                  </div>
                ))}
            </Slider>
          </div>
        </div>

        <div className="admin-application-status rounded-bottom-3 position-relative bg-white z-1">
          <Tabs
            // defaultActiveKey="backgroundCheck"
            className="p-3"
            activeKey={activeTab}
            onSelect={handleChangeTab}
          >
            <Tab eventKey="backgroundCheck" title="Overview">
              <Overview gid={gid} is360View={true} />
            </Tab>
            <Tab eventKey="email" title="Email">
              {activeTab === "email" && <Email is360View={true} />}
            </Tab>
            <Tab eventKey="documents" title="Documents">
              {activeTab === "documents" && <Document is360View={true} />}
            </Tab>
            {/* <Tab eventKey="activity" title="Activity">
                <Activity />
              </Tab> */}
          </Tabs>
        </div>
      </div>
    </main>
  );
};
